define([
    'text!WebCommon/menu/talk-btn.html',
    'jquery',
    'WebCommon/mixin/auth',
    'lodash',
    'WebCommon/utils',
    'web/common/modal/modal',

    'bbq',
    'css!WebCommon/menu/talk-btn.css'
], function(
    tpl,
    $,
    AuthMixin,
    _,
    Utils,
    Modal
){
    var chatOrigin = '//talk.fnji.com';
    var hidePages = [
        '/fnjihome',
        '/fnjidrop',
        '/fnjiartist',
        '/fnjiad',
        '/fnjithings'
    ];
    hidePages = _.map(hidePages, Utils.genPageLink);

    return {
        template: tpl,
        mixins: [AuthMixin],
        data: function(){
            return {
                chatOrigin: chatOrigin,
                hidePages: hidePages,
                isShow: false,
                hashKey: 'showChat'
            };
        },
        computed: {
            chatJsUrl: function(){
                return this.chatOrigin + '/php/app.php?widget-init.js';
            },
            hasNewMessageUrl: function(){
                return this.chatOrigin + '/php/app.php?guest-has-unread-message';
            },
            isHidePage: function(){
                var pathname = location.pathname;
                return _.some(this.hidePages, function(o){
                    return pathname.indexOf(o) === 0;
                });
            }
        },
        methods: {
            init: function(){
                if (this.isHidePage) return;
                var _this = this;
                $.getScript(_this.chatJsUrl)
                    .done(function(){
                        if (!window.phpLiveChat) {
                            return onError();
                        }
                        _this.isShow = true;
                        _this.checkShowChatHash();
                    })
                    .fail(onError);

                function onError(){
                    console.warn('Load Chat JS Error');
                }
            },
            toggle: function(){
                if (!window.phpLiveChat) return;
                if (!this.isLoggedIn){
                    var obj = {};
                    obj[this.hashKey] = 1;
                    var from = $.param.fragment(location.href, obj);
                    Modal.showMemberLoginModal(from);
                } else {
                    window.phpLiveChat.toggle();
                }
            },
            checkShowChatHash: function(){
                var hashObj = $.deparam.fragment();
                var key = this.hashKey;
                if (hashObj[key]) {
                    delete hashObj[key];
                    var url = $.param.fragment(location.pathname+location.search, hashObj);
                    location.replace(url);
                    this.toggle();
                }
            }
        },
        mounted: function(){
            this.init();
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ../common/menu/talk-btn.js
// module id = 73
// module chunks = 0 1 2 3 4 5 6 7 8